import React, { ReactElement, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Payer } from '../../models/payer.model';
import { RootState } from '../../../store';
import * as actionTypes from '../../../store/actions/payerListAction';
import './payerList.less';
import { MailboxType } from '../../../store/models/mailBoxModel';
import { canActivate, centeredNotification, isGroupUser } from '../../../utils/utility';
import useGetPasswordExpireNotification from '../../hooks/useGetPasswordExpireNotification';
import { fetchAllOnMailPayers } from '../../../store/actions/lookUpAction';
import { fetchPayerConfig, setCenterId, setEnabledPayer } from '../../../store/actions/mailBoxAction';
import { authFeatureConstants, PASSWORD_NOT_VERIFIED_ERROR } from '../../constants/commonConstants';
import { PayerInitialState } from '../../../store/models/payerListModel';
import { getIsPageReimbursement } from '../../../modules/reimbursement/reimbursementUtil';
import { useHistory } from 'react-router-dom';
import { NewAdmissionState } from '../../../store/models/newAdmissionModel';
import { NHCXState } from '../../../store/models/nhcxModel';
import ApplicationDetail from '../../services/applicationDetail.service';
import { isEmpty } from 'lodash';
import { customGTMEvent } from '../../../modules/crm/inPatient/service/crmUtils';
import { ApplicationDetailModel } from '../../../store/models/applicationDetailModel';
import { setIsShowAdmissionForm, setShowPayerNotConfiguredMessage, setShowPayerUpdatedMessage } from '../../../store/actions/newAdmissionAction';
import { Button, Select } from 'antd';
import './payerList.less';
import { ReactComponent as DownArrow} from '../../../assets/images/svg/DownArrow.svg';
import FormSelectPayerDropdown from '../crmFormElement/FormSelect/FormSelectPayerDropdown';

interface PayerOption extends Payer {
  isEmailNotConfigured?: boolean;
  customComponent?: ReactElement;
}

const PayerList = ({
  size, isLoading, hideLabel, NHCXSearch, className, HISPayerValue,
  data, _placeholder = '', isCenterSelected, form, groupProviders, centerId, onPanelLeave,
}: any): ReactElement => {
  const { allPayers: configuredPayers, reimbursementPayers } = useSelector((state: RootState): PayerInitialState => state?.payerList || {});
  const onMailPayers = useSelector((state: RootState): Payer[] => state?.lookUp?.onMailPayers || []);
  const dispatch = useDispatch();
  const history = useHistory();
  const getNotification = useGetPasswordExpireNotification();
  const { hospitalConfiguration: emailConfiguration = {} as any, payerConfiguration = {} as any } =
  useSelector((state: RootState): MailboxType => state?.mailBox || {});
  const [optionData, setOptionData] = useState<Payer[]>([]);
  const { passwordExpire } = emailConfiguration || {};
  let isEmailVerified = emailConfiguration;
  isEmailVerified = emailConfiguration === undefined || emailConfiguration === null ? true : isEmailVerified;
  const { payers } = payerConfiguration || {};
  const {isDraftSelected} =
  useSelector((state: RootState): NewAdmissionState => state.newAdmission);
  const {selectedPolicyDetail} = useSelector((state: RootState): NHCXState => state.nhcx);
  const isNHCXEnabledProvider = ApplicationDetail.instance.getIsNHCXEnabledProvider();
  const appDetail = useSelector((state: RootState): ApplicationDetailModel => state.applicationDetail);
  const {beneficiarySearchResponsePayerId}: any = useSelector((state: RootState): NewAdmissionState =>  state.newAdmission);
  const isPreAuthNewDesignEnabled = appDetail?.getIsPreAuthClaimViewEnabled();
  const isMailboxConfigEnabled = appDetail?.getIsNewMailboxConfigEnabled();
  const providerId = appDetail.getProviderId();

  useEffect((): any => {
    dispatch(fetchAllOnMailPayers());
    if (!groupProviders?.length) {
      dispatch(fetchPayerConfig(providerId));
    }
  }, []);

  const isNewAdmissionOnBehalf = canActivate(authFeatureConstants.NEW_ADMISSION_BEHALF_OF_HOSPITALS) && isGroupUser();

  useEffect((): void => {

    const filteredPayers = configuredPayers?.filter((payer: Payer): boolean => !payer?.blockedActions?.NEWADMISSION);
    const updatedConfiguredPayers = filteredPayers?.map((payer: any): any => {
      if (passwordExpire && (payer?.isOnMailPayer || payer?.isRpaPayer)) {
        return {
          ...payer,
          showReconfigure: true,
          customComponent: (
            <Select.Option
              key={String(payer?.id)}
              value={String(payer?.id)}
              className="clr-disabled mailbox-flex-container select-options-expired mouse-pointer-default"
            >
              <div
                className={`flx-center w-100`}
                onClick={(event: any): any => event?.stopPropagation()}>
                <span onClick={(event: any): any => event?.stopPropagation()} className={isPreAuthNewDesignEnabled ? 'redesign-payer-dropdown' : ''}>{payer?.name}</span>
                  <Button
                  id={`reconfigure-click-payer-track-${payer?.id}`}
                  data-testid={`multipayer-reconfigure-now-${payer?.id}`}
                  target="_blank"
                  className={isPreAuthNewDesignEnabled ? 'redesign-payerDropdown-reconfigurebtn' : 'payerDropdown-reconfigurebtn'}
                  size="small"
                  type="link"
                  onClick={(event: any): void => reconfiguringPayer(event)}
                >
                  Reconfigure Hospital
                </Button>
              </div>
            </Select.Option>
          ),
        };
      }
      return payer;
    });
    if (getIsPageReimbursement(history.location.pathname)) {
      setOptionData(reimbursementPayers || []);
    } else {
      let disabledPayers: any[] = [];

      disabledPayers = payerConfiguration?.filter((payer: any): any => !payer?.isEnabled)?.map((disabledPayer: any): any => ({
        ...disabledPayer,
        id: disabledPayer?.payerID,
        name: disabledPayer?.payerName,
        value: disabledPayer?.payerID,
        isRpaPayer: disabledPayer?.isRPAPayer,
        isOnMailPayer: !disabledPayer?.isRPAPayer,
        uniqueIdentifier: disabledPayer?.payerID,
        disabled: true,
        customComponent: (
          <Select.Option
            key={String(disabledPayer?.payerID)}
            value={String(disabledPayer?.payerID)}
            disabled={true}
            className="clr-disabled content-flex-between disabled-options mouse-pointer-default"
          >
            {disabledPayer?.payerName}
            <Button
              id={`enable-click-payer-track-${disabledPayer?.payerID}`} // Ensure unique ID
              data-testid={`multipayer-enable-now-${disabledPayer?.payerID}`} // Ensure unique test ID
              target="_blank"
              className="ghost-primary-btn payerDropdown-enablebtn"
              size="small"
              type="ghost"
              onClick={(event: any): void => enablingPayer(event, disabledPayer?.payerID)}
            >
              Enable Now
            </Button>
          </Select.Option>
        ),
      }));
      const finalOptions = !data
        ? updatedConfiguredPayers?.map((p: Payer): PayerOption => ({ ...p, isEmailNotConfigured: false }))
          .concat?.(disabledPayers)
        : data?.concat?.(disabledPayers);

      const emailPayers = finalOptions?.reduce((acc: PayerOption[], ele: PayerOption): any => {
        const selectedPayer = payerConfiguration?.find((item: any): any => ele?.id === item['payerID']);

        if (ele?.isOnMailPayer || ele?.isCorporatePayer) {
          ele['disabled'] = !selectedPayer?.isEnabled;
        }
        if (ele?.isRpaPayer && !selectedPayer?.isEnabled) {
          ele['disabled'] = true;
        }

        const existingPayerIndex = acc?.findIndex((payer: any): any =>
          (payer?.shortName && ele?.shortName && payer?.shortName === ele?.shortName));
        if (existingPayerIndex > -1) {
          const existingPayer = acc[existingPayerIndex];
          const hasNoRpaOrMail = !ele?.isRpaPayer && !ele?.isOnMailPayer && !ele?.blockedActions?.NEWADMISSION;
          if (!existingPayer?.isRpaPayer && !existingPayer?.isOnMailPayer && !existingPayer?.blockedActions?.NEWADMISSION) {
            // Keep the existing one if it has neither isRpaPayer nor isOnMailPayer and does not block NEWADMISSION
          } else if (hasNoRpaOrMail) {
            acc[existingPayerIndex] = ele; // Replace with current ele if it meets the new strongest condition
          } else if (ele?.isRpaPayer && existingPayer?.isOnMailPayer) {
            acc[existingPayerIndex] = ele; // Replace with isRpaPayer if existing is isOnMailPayer
          } else if (ele?.isOnMailPayer && existingPayer?.isRpaPayer) {
            acc[existingPayerIndex] = ele; // Replace with isOnMailPayer if existing is isRpaPayer
          }
        } else {
          acc?.push(ele);
        }

        return acc;
      }, []);

      setOptionData(emailPayers);
    }

  }, [configuredPayers, data, passwordExpire, onMailPayers, isEmailVerified, payerConfiguration]);

  const enablingPayer = (e: any, key: any): any => {
    e?.stopPropagation();
    dispatch(setEnabledPayer(key));
    dispatch(setCenterId(centerId));
    if (isMailboxConfigEnabled) {
      history?.push('/profile/mailbox/payer');
    }
  };

  const reconfiguringPayer = (e: any): any => {
    e?.stopPropagation();
    if (isMailboxConfigEnabled) {
      history?.push('/profile/mailbox/hospital');
    }
  };

  const payerChangeHandler = (uniqueId: string): void => {
    if (uniqueId) {
      const payerDetail: Payer | undefined = optionData.find(
        ({ uniqueIdentifier }: Payer): boolean => uniqueIdentifier === uniqueId,
      );
      dispatch(setShowPayerNotConfiguredMessage(false));
      dispatch(setShowPayerUpdatedMessage(false));
      dispatch(setIsShowAdmissionForm(false));
      // Prevent selection if the payer requires reconfiguration and passwordExpire is true
      if (passwordExpire && (payerDetail?.isOnMailPayer || payerDetail?.isCorporatePayer)) {
        return;
      }
      if (payerDetail && !isDraftSelected) {
        dispatch(actionTypes.changePayer(payerDetail));
        const selectedPayer = payers?.find((item: any): any =>
          payerDetail?.id === item['payerID'],
        );
        if (payerDetail.isRpaPayer && (selectedPayer && selectedPayer?.isEnabled === false)) {
          centeredNotification(PASSWORD_NOT_VERIFIED_ERROR);
        } else if ((payerDetail?.isOnMailPayer || payerDetail?.isCorporatePayer) && passwordExpire) {
          centeredNotification(
            'Wrong payer',
            'error',
            (): any => getNotification(),
          );
        }
      }
      customGTMEvent({
        event: 'Payer Dropdown Selection',
        payerName: payerDetail?.name,
        payerId: payerDetail?.id,
      });
    }
  };

  useEffect((): any => {
    if (beneficiarySearchResponsePayerId > 0) {
      const finalPayer = configuredPayers.find((p: any): any => (p.id === beneficiarySearchResponsePayerId && p.isGovtScheme === false));
      if (finalPayer) {
        payerChangeHandler(String(beneficiarySearchResponsePayerId));
        form.setFieldsValue({ payer: finalPayer?.name });
      }
    }
  }, [beneficiarySearchResponsePayerId]);

  const checkDisabled = (): any => {
    if (isDraftSelected ||
      (isNHCXEnabledProvider && !isEmpty(selectedPolicyDetail)) ||
      (isNewAdmissionOnBehalf && !isCenterSelected)) {
      return true;
    }
  };

  const hasDisabledPayers = optionData?.some((option: any): any => option?.disabled);

  return (
    <FormSelectPayerDropdown detail={{
      isLoading,
      allowClear: false,
      size,
      showSearch: true,
      key: 'payer',
      required: true,
      hideLabel,
      onChange: payerChangeHandler,
      isEmailVerified,
      options: optionData,
      enablingPayer,
      disabled: checkDisabled(),
      className: className ? className : 'Payer-Dropdown',
      form,
      suffixIcon: !NHCXSearch ? <DownArrow /> : '',
      hasDisabledPayers,
      onPanelLeave,
      HISPayerValue,
    }} />
  );
};

export default PayerList;
